import { combineSlices, configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { ConfigSlice } from '@/redux/config';
import { DialogSlice } from '@/redux/dialog';
import { GeneralSlice } from '@/redux/general';
import { ModalSlice } from '@/redux/modal';
import { SliderSlice } from '@/redux/slider';
import { UserFormSlice } from '@/redux/user-form';

export const rootReducer = combineSlices(
  ConfigSlice,
  DialogSlice,
  GeneralSlice,
  ModalSlice,
  SliderSlice,
  UserFormSlice,
);

export const store = configureStore({
  reducer: persistReducer(
    {
      key: 'root',
      storage,
      whitelist: [GeneralSlice.name, SliderSlice.name],
      version: 1,
    },
    rootReducer,
  ),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);

export type AppState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export const useAppSelector = useSelector.withTypes<AppState>();
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
